
import { Link } from "react-router-dom";
import bonding from "../../Images/bonding.jpg";
import bonding1 from "../../Images/bonding1.jpg";
import bonding2 from "../../Images/bonding2.jpg";
import bonding3 from "../../Images/bonding3.jpg";
import bonding4 from "../../Images/bonding4.jpg";
import bonding5 from "../../Images/bonding5.jpg";
import bonding6 from "../../Images/bonding6.jpg";




import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";


export default function Bonding() {
  return (
    <>
    <div
      className=" relative w-full min-h-[300px] sm:min-h-[400px] lg:min-h-[350px]
        bg-cover bg-[center_40%] flex items-center pt-28 sm:pt-32 "
      style={{ backgroundImage: `url(${bonding1})` }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/55"></div>
    
      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1
          className=" text-white font-extrabold text-center text-3xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-4xl
            leading-tight pt-5 pb-1 max-w-5xl -mt-12 sm:mt-0 mx-auto drop-shadow-[0_6px_20px_rgba(0,0,0,0.7)]" >
          Dental Bonding - Before and After
        </h1>
      </div>
      </div>


<div className=" px-2 py-2 mt-12">
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">

        {/* left Image */}
      <div>
        <img
          src={bonding}
          alt="Dental Consultation"
          className="w-full h-[380px] object-cover rounded-2xl"
        />
      </div>

      {/* right Content */}
      <div>
        <h1 className="text-3xl font-semibold text-[#0a0a5c] mb-3">
            Curious about what dental bonding can do for your smile?
        </h1>

        <p className="text-gray-900 ">
        Dental bonding is a great way to improve the appearance of your teeth without having to go through surgery. Our dentists are experts in this procedure and may be able to help you achieve the smile you always wanted. You don’t have to be embarrassed about your smile any longer. Dental bonding can fix chips, cracks, and other imperfections quickly and easily. And thanks to the advancements in dental technology, dental bonding looks more natural than ever before. Just take a look at our before and after photos to see for yourself.


        </p>
      </div>
</div>
  </div>
</div>

<div className="max-w-7xl mx-auto px-4 py-10">
  <h2 className="text-center text-3xl font-semibold text-[#0a0a5c] mb-8">
    Dental Bonding - Before and After Pictures
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
    {/* Item */}
    <div className="space-y-2">
      <div className="relative">
        <img
          src={bonding2}
          alt="Before"
          className="w-full h-58 object-cover rounded-lg"
        />
        
      </div>
      <div className="relative">
        <img
          src={bonding3}
          alt="After"
          className="w-full h-58 object-cover rounded-lg"
        />
        
      </div>
    </div>

    {/* Repeat same block */}
    <div className="space-y-2">
      <div className="relative">
        <img src={bonding4} alt="Bonding treatment before and after" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
      <div className="relative">
        <img src={bonding5} alt="Dental bonding results" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
    </div>

    <div className="space-y-2">
      <div className="relative">
        <img src={bonding6} alt="Cosmetic dental bonding procedure" className="w-full h-58 object-cover rounded-lg" />
        
      </div>
      
    </div>    
  </div>
</div>

<div className="max-w-7xl mx-auto px-6 py-4">
  <div className="grid grid-cols-1 md:grid-cols-2 gap-16">

    {/* LEFT COLUMN */}
    <div>
      <h1 className=" text-[#0a0a5c] font-semibold text-3xl mb-6">
        Things to Know Before You Get Dental Bonding
      </h1>
      <p>
        If you’re considering dental bonding, there are a few things you should know first.

          </p>

      <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
          1. Procedure can be done in just one visit
          </h4>
          <p>
            If you don’t have time for multiple dental visits, bonding might be a good option for you. The procedure can usually be done in just one visit to the dentist.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            2. Usually, you don't need anesthesia
          </h4>
          <p>
            Most people don’t need anaesthesia for dental bondings. If your dentist is going to bond a large area, you might be given a local anesthetic to numb the area.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            3. It may be used to fix a variety of dental problems
          </h4>
          <p>
            Dental bonding may be used to fix a number of different dental problems, including:
          <ul className="list-disc pl-10 space-y-1">
            <li>Chipped teeth</li>
            <li>Cracked teeth</li>
            <li>Gaps between teeth</li>
            <li>Misshapen teeth</li>
            <li>Stained or discoloured teeth</li>
          </ul>
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            4. Bonding usually lasts for 3 to 5 years
          </h4>
          <p>
            With proper care, dental bonding usually lasts for 3 to 5 years. After that, it will likely need to be replaced.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
          5. It's not as strong as other options
          </h4>
          <p>
            Dental bonding is not as strong as other dental options, such as veneers or crowns. It’s more likely to chip or break than other options.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
          6. It's not suitable for everyone
          </h4>
          <p>
            Dental bonding might not be suitable for everyone. If you have very large dental problems, bonding might not be the best option. Your dentist will be able to advise you on whether or not dental bonding is right for you.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
          7. Health insurance covers dental bonding
          </h4>
          <p>
            Health insurance usually covers dental bonding. However, you might have to pay a deductible or copayment. Check with your insurance company to see what is covered.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
          8. May help with sensitive teeth
          </h4>
          <p>
            Dental bonding may help with sensitive teeth by protecting the root of the tooth. So if you feel like you may need dental bonding, talk to one of our experienced dentists. They may be able to tell you if it is the right option for you.
          </p>
        </div>

        
      </div>
    </div>

    {/* RIGHT COLUMN */}
    <div>
      <h1 className=" text-[#0a0a5c] font-semibold text-3xl mb-6">
        Things to Know After You Get Dental Bonding
      </h1>

      <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            1. You might feel some sensitivity

          </h4>
          <p>
          After you get dental bonding, you might feel some sensitivity in your teeth. This is normal and should go away within a few days. If the sensitivity doesn’t go away, or if it gets worse, call your dentist.

          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
        2. Avoid hard foods
          </h4>
          <p>
          You should avoid hard foods for the first few days after you get dental bonding. This will help prevent your bonding from chipping or breaking.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            3. Be careful with your teeth
          </h4>
          <p>
         You need to be careful with your teeth after you get dental bonding. Avoid chewing on hard objects, such as ice or hard candy. This can damage your bonding.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
          4. Brush and floss regularly
          </h4>
          <p>
          You should brush and floss your teeth regularly to keep them healthy. This will also help prevent your bonding from getting stained.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            5. See your dentist for regular checkups

          </h4>
          <p>
            You should see your dentist for regular checkups. They will be able to check on your bonding and make sure it is still in good shape.
          </p>
        </div>

        <div>
          <h4 className="font-semibold  text-[#0a0a5c]">
            6. Get your bonding replaced when it starts to wear

          </h4>
          <p>
            You will need to get your bonding replaced when it starts to wear down. This is usually after 3 to 5 years. So if you have just gotten dental bonding, be sure to follow these tips to keep your teeth healthy. And if you have any questions, feel free to ask us or consult with one of our experienced dentists.
          </p>
        </div>

        
      </div>
    </div>
  </div>
</div>

<div className="w-full h-[180px] overflow-hidden mt-4">
  <iframe
    title="clinic-map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.0390050498395!2d71.9162331!3d30.292951199999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b557588a60575%3A0x79afa5462675bee1!2sSmile%20expert%20dental%20clinic!5e0!3m2!1sen!2s!4v1767274320473!5m2!1sen!2s"
    width="100%"
    height="450"
    style={{ border: "0" }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</div>

<div className="bg-[#0c2340] text-white pt-[60px] pb-[60px] px-[40px] mt-0">
  <div className="flex justify-between flex-wrap max-w-[1400px] mx-auto gap-[40px]">
    {/* COLUMN 1 */}
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Useful Links</h3>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    About Us
  </Link>

  <Link to="/contact" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Contact Us
  </Link>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Meet the Team
  </Link>

  <Link to="/teeth-whitening-before-and-after" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Before & After
  </Link>

  <Link to="/blog" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Blogs
  </Link>
</div>


    
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Treatments</h3>

  <Link to="/treatment/exam" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Exam & X-Rays Check-Up
  </Link>

  <Link to="/emergency-dentist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Emergency
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Smile Makeover
  </Link>

  <Link to="/t/veneer" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Veneers
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Implants
  </Link>

  <Link to="t/canals" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Root Canal Treatment
  </Link>

  <Link to="/t/orthodontist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Orthodontic Braces
  </Link>

  
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Dental Problems</h3>

  <Link to="/yellow-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Yellow Teeth
  </Link>

  <Link to="/teeth-cleaning" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Teeth Cleaning
  </Link>

  <Link to="/missing-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Missing Teeth
  </Link>

  <Link to="/broken-chipped-tooth" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Broken Chipped Tooth
  </Link>

  <Link to="/gum-disease" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Gum Disease
  </Link>

  <Link to="/crooked-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Crooked Teeth
  </Link>

  <Link to="/sore-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Sensitive & Sore Teeth
  </Link>

  <Link to="/dental-anxiety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Anxiety
  </Link>
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Patient Safety</h3>

  <Link to="/7x-safety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    7X SAFETY
  </Link>

  <Link to="/4-step-sterilization" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    4 Step Sterilization
  </Link>

  <Link to="/safety-equipment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Safety Equipment
  </Link>

  <Link to="/equipment-technology" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Equipment & Technology
  </Link>

  <Link to="/quality" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Quality
  </Link>
</div>


    <div className="min-w-[250px]">
              <h3 className="text-[20px] mb-[20px]">Get in touch</h3>
        
              <p className="my-2 flex gap-[10px] ">📧 aneelabrar555@gmail.com</p>
        
              <p className="my-3 flex gap-[10px]  ">📞 03008395562</p>
        
              <p className="my-2 flex gap-[10px] px-2">
                  <span className="">📍 Saddique Hospital Stadium Road Khanewal</span>
              </p>
        
              <p className="mt-6 font-semibold "> 🕒 Clinic Timing <br/>   <span className="ml-7">11:00am to 9:00pm</span></p>
        
              <div className="text-left bg-[#0c2340] text-white py-[50px] px-[20px]">
                <div className="flex gap-[15px] mt-[20px]">
                  <a

                      href="https://www.facebook.com/share/17zJppb7qh/"

                      target="_blank"

                      rel="noopener noreferrer"

                      className="w-[35px] h-[35px] bg-blue-900 flex justify-center items-center rounded-[8px] no-underline"

                      aria-label="Follow us on Facebook"

                    >

                      <FaFacebookF size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://instagram.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#000000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Follow us on Instagram"

        
                    >

        
                      <FaInstagram size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://youtube.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#FF0000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Subscribe to our YouTube channel"

        
                    >

        
                      <FaYoutube size={22} color="white" />
                  </a>
                </div>
              </div>
            </div>
    
  </div>
   <div className="w-full text-center justify-end mb-0 border-t border-gray-300 pt-4">
  <p className="text-sm text-gray-400">
    © SmileExpert
    <span className="mx-2 text-gray-600">|</span>
    Powered by{" "}
    <a
      href="https://verdant-soft.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-blue-400 no-underline font-medium transition-colors duration-300 "
    >
      Verdant Soft
    </a>
  </p>
</div>

</div>






</>
  )
}








